// ColorPicker component
import React from "react";
import { SketchPicker } from "react-color";

const ColorPicker = ({ value, onChange }) => {
  return (
    <div className="form-group ">
      <label className=" " style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}>Color</label>
      <SketchPicker 
        className="mt-1"
        color={value || '#ffffff'}
        onChangeComplete={(color) => onChange(color.hex)}
      />
    </div>
  );
};

export default ColorPicker;